module.exports = __webpack_public_path__ + "img/attività_todolist.d7fe4808.png";